module.exports = __webpack_public_path__ + "img/BT.06742cf8.svg";